import BaseApi from './BaseApi';
import Township from 'src/models/Township';
import Section from 'src/models/Section';
import TractDetailFormData from '../models/tract_detail/TractDetailFormData';
import Ownership from '../models/tract_detail/Ownership';
import ExaminedHistoryChanges from 'src/models/tract_detail/ExaminedHistoryChanges';

// import MockTract from  './mocks/Tract';
import AddOwnershipCollection from 'src/models/tract_detail/add_ownership_collection/AddOwnershipCollection';
import NewTract from 'src/models/tract_detail/NewTract';
import { ODataOptions } from 'src/util/ODataBuilder';
import AddOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddOwnership';
import CreateHorizonDto from 'src/models/tract_detail/CreateHorizonDto';
import TractDetailData from 'src/models/tract_detail/TractDetail';
import { HorizonInterval, Formation } from 'src/models/Horizon';
import TractDetail from 'src/models/tract_detail/TractDetail';
import { AnyObject } from 'final-form';
import EasternTownship from 'src/models/EasternTownship';
import EasternMap from 'src/models/EasternMap';
import { IAppContextState } from 'src/reducers/AppContext';
import { UrlFactory } from './urlHelper';

export interface ITract {
    getTractDetail(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        options: ODataOptions,
        jwt: string
    ): Promise<object>;
    // TODO: move to project api - next 5 (7?)
    getTownships(clientNumber: number, projectNumber: number, jwt: string): Promise<object>;
    getEasternTownships(clientNumber: number, projectNumber: number, jwt: string): Promise<object>;
    getTownship(clientNumber: number, projectNumber: number, townshipId: number, jwt: string): Promise<object>;
    getEasternTownship(clientNumber: number, projectNumber: number, townshipId: number, jwt: string): Promise<object>;
    getSectionsByTownship(clientNumber: number, projectNumber: number, townshipId: number, jwt: string): Promise<object>;
    getMapsByEasternTownship(clientNumber: number, projectNumber: number, townshipId: number, jwt: string): Promise<object>;
    getEasternMap(clientNumber: number, projectNumber: number, mapNumber: number, jwt: string): Promise<object>;
    getMeridiansByProject(clientNumber: number, projectNumber: number, jwt: string): Promise<object>;
    createTownship(clientNumber: number, projectNumber: number, township: Township, jwt: string): Promise<object>;
    createEasternTownship(clientNumber: number, projectNumber: number, township: EasternTownship, jwt: string): Promise<object>;
    updateTownship(clientNumber: number, projectNumber: number, township: Township, jwt: string): Promise<object>;
    createSection(clientNumber: number, projectNumber: number, townshipId: number, section: Section, jwt: string): Promise<object>;
    updateSection(clientNumber: number, projectNumber: number, townshipId: number, section: Section, jwt: string): Promise<object>;
    getTractsByOwner(clientNumber: number, projectNumber: number, sectionNumber: number, ownerId: number, jwt: string): Promise<object>;
    getSurfaceTractsByOwner(clientNumber: number, projectNumber: number, fieldNumber: number, ownerId: number, jwt: string): Promise<object>;
    saveTractDetail(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        tract: TractDetailFormData,
        jwt: string
    ): Promise<object>;
    getOwnershipDetail(ownerId: number, horizonId: number, projectId: number, tractId: number, jwt: string): Promise<object>;
    getTracts(clientNumber: number, projectNumber: number, sectionNumber: number, jwt: string): Promise<object>;
    getCloneTracts(clientNumber: number, projectNumber: number, sectionNumber: number, jwt: string): Promise<object>;
    createHorizon(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizon: CreateHorizonDto,
        jwt: string
    ): Promise<object>;
    updateHorizonInterval(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonId: number,
        horizon: HorizonInterval,
        jwt: string
    ): Promise<object>;
    updateTractNote(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        tractDetailData: TractDetailData,
        jwt: string
    ): Promise<object>;
    updateOwnerNote(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownership: Ownership,
        jwt: string
    ): Promise<object>;
    saveExaminedHistory(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        examinedHistoryChanges: ExaminedHistoryChanges,
        jwt: string
    ): Promise<object>;
    deleteOwnershipDetail(projectId: number, ownershipDetailId: number, jwt: string): Promise<object>;
    // getOwnerDetails(projectId: number, ownerId: number, jwt: string): Promise<object>;
    saveAddOwnershipCollection(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        addOwnershipCollection: AddOwnershipCollection,
        jwt: string
    ): Promise<object>;
    createTract(clientNumber: number, projectNumber: number, sectionNumber: number, newTract: NewTract, jwt: string): Promise<object>;
    deleteTract(clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, jwt: string): Promise<object>;
    deleteSection(clientNumber: number, projectNumber: number, sectionNumber: number, jwt: string): Promise<object>;
    deleteTownship(clientNumber: number, projectNumber: number, townshipId: number, jwt: string): Promise<object>;
    getSearchPagedOwners(clientNumber: number, projectNumber: number, options: ODataOptions, jwt: string): Promise<object>;
    getSearchOwners(clientNumber: number, projectNumber: number, searchText: string, ownerType: string, jwt: string): Promise<object>;
    getFormations(clientNumber: number, projectNumber: number, jwt: string): Promise<object>;
    createFormation(clientNumber: number, projectNumber: number, formation: Formation, jwt: string): Promise<object>;
    getPagedOwnerships(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        options: ODataOptions,
        jwt: string
    ): Promise<object>;
    sequenceHorizons(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        sequence: Array<{ id: number; sequence: number }>,
        jwt: string
    ): Promise<object>;
    getUniqueHorizonIntervals(clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, jwt: string): Promise<object>;
    saveAddOwnership(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        owner: AddOwnershipData,
        jwt: string
    ): Promise<object>;
    getTractOwners(clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, jwt: string): Promise<object>;
    getTownshipSectionsForSectionNumber(clientNumber: number, projectNumber: number, sectionNumber: number, jwt: string): Promise<object>;
    deleteOwnership(clientNumber: number, projectNumber: number, sectionNumber: number, ownershipId: number, jwt: string): Promise<object>;
    deleteHorizon(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        jwt: string
    ): Promise<object>;
    promoteAdditionalOwnership(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        ownershipId: number,
        jwt: string
    ): Promise<object>;
    getCityState(zipCode: string, jwt: string): Promise<object>;
    createEasternMap(clientNumber: number, projectNumber: number, townshipId: number, map: EasternMap, jwt: string): Promise<Object>;
}

export default class Tract extends BaseApi implements ITract {
    // private mockTract: ITract;

    constructor(baseURL: string) {
        super(baseURL);
    }

    getHorizonPartType = (typeCode: number) => {
        if (typeCode === 0) {
            return 'extent' as 'extent' | 'depth' | 'custom' | 'formation';
        } else if (typeCode === 1) {
            return 'formation' as 'extent' | 'depth' | 'custom' | 'formation';
        } else if (typeCode === 2) {
            return 'depth' as 'extent' | 'depth' | 'custom' | 'formation';
        } else {
            return 'custom' as 'extent' | 'depth' | 'custom' | 'formation';
        }
    };

    getTractDetail = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        options: ODataOptions,
        jwt: string
    ) => {
        // tslint:disable-next-line:max-line-length
        return this.getRequest(
            `${
                this.baseUrl
            }v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/horizons/${horizonNumber}/${
                options ? options.toString() : ''
            }`,
            jwt
        ).then((data: TractDetail) => {
            for (let i = 0; i < data.horizons.length; i++) {
                const hi = data.horizons[i].horizonInterval;

                hi.from.type = this.getHorizonPartType((hi as AnyObject).from.type as number);
                hi.to.type = this.getHorizonPartType((hi as AnyObject).to.type as number);
            }
            return data;
        });
    };

    getTracts = (clientNumber: number, projectNumber: number, sectionNumber: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts`, jwt);
    };

    getCloneTracts = (clientNumber: number, projectNumber: number, sectionNumber: number, jwt: string) => {
        return this.getRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/tract-details`,
            jwt
        );
    };

    getTownships = (clientNumber: number, projectNumber: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/townships`, jwt);
    };

    getEasternTownships = (clientNumber: number, projectNumber: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/eastern-townships`, jwt);
    };

    getTownship = (clientNumber: number, projectNumber: number, townshipId: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/townships/${townshipId}`, jwt);
    };

    getEasternTownship = (clientNumber: number, projectNumber: number, townshipId: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/eastern-townships/${townshipId}`, jwt);
    };

    getEasternMap = (clientNumber: number, projectNumber: number, mapNumber: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/maps/${mapNumber}`, jwt);
    };

    getSectionsByTownship = (clientNumber: number, projectNumber: number, townshipId: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/townships/${townshipId}/sections`, jwt);
    };

    getMapsByEasternTownship = (clientNumber: number, projectNumber: number, townshipId: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/eastern-townships/${townshipId}/maps`, jwt);
    };

    getMeridiansByProject = (clientNumber: number, projectNumber: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/meridians`, jwt);
    };

    createTownship = (clientNumber: number, projectNumber: number, township: Township, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/townships`, township, jwt);
    };

    createEasternTownship = (clientNumber: number, projectNumber: number, township: EasternTownship, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/eastern-townships`, township, jwt);
    };

    createEasternMap = (clientNumber: number, projectNumber: number, townshipId: number, map: EasternMap, jwt: string) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/eastern-townships/${townshipId}/maps`,
            map,
            jwt
        );
    };

    updateTownship = (clientNumber: number, projectNumber: number, township: Township, jwt: string) => {
        return this.putRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/townships`, township, jwt);
    };

    createSection = (clientNumber: number, projectNumber: number, townshipId: number, section: Section, jwt: string) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/townships/${townshipId}/sections`,
            section,
            jwt
        );
    };

    updateSection = (clientNumber: number, projectNumber: number, townshipId: number, section: Section, jwt: string) => {
        return this.putRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/townships/${townshipId}/sections`,
            section,
            jwt
        );
    };

    saveTractDetail = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        formValues: TractDetailFormData,
        jwt: string
    ) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/horizons/${horizonNumber}/save-tract-detail`,
            formValues,
            jwt
        );
    };

    getOwnershipDetail = (ownerId: number, horizonId: number, projectId: number, tractId: number, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/projects/${projectId}/tracts/${tractId}/horizons/${horizonId}/owners/${ownerId}`, jwt);
    };

    createHorizon = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizon: CreateHorizonDto,
        jwt: string
    ) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/create-horizon`,
            horizon,
            jwt
        );
    };

    updateHorizonInterval = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        horizonInterval: HorizonInterval,
        jwt: string
    ) => {
        // tslint:disable-next-line:max-line-length
        return this.putRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/horizons/${horizonNumber}/horizon-interval`,
            horizonInterval,
            jwt
        );
    };

    updateTractNote = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        tractDetailData: TractDetailData,
        jwt: string
    ) => {
        // tslint:disable-next-line:max-line-length
        return this.putRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/tract-note`,
            tractDetailData,
            jwt
        );
    };

    updateOwnerNote = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownership: Ownership,
        jwt: string
    ) => {
        console.log('tractAPI fired');
        // tslint:disable-next-line:max-line-length
        return this.putRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/ownership-note`,
            ownership,
            jwt
        );
    };

    saveExaminedHistory = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        examinedHistoryChanges: ExaminedHistoryChanges,
        jwt: string
    ) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/save-examined-history`,
            examinedHistoryChanges,
            jwt
        );
    };

    deleteOwnershipDetail = (projectId: number, ownershipDetailId: number, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/projects/${projectId}/tracts/delete-ownership-detail`, { ownershipDetailId }, jwt);
    };

    getOwnerDetails = (projectId: number, ownerId: number, jwt: string) => {
        // return this.mockTract.getOwnerDetails(projectId, ownerId, jwt);
        return this.getRequest(`${this.baseUrl}v1.0/projects/${projectId}/tracts/owner-details/${ownerId}`, jwt);
    };

    saveAddOwnershipCollection = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        addOwnershipCollection: AddOwnershipCollection,
        jwt: string
    ) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/save-add-ownership`,
            addOwnershipCollection,
            jwt
        );
    };

    createTract = (clientNumber: number, projectNumber: number, sectionNumber: number, newTract: NewTract, jwt: string) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/create-tract`,
            newTract,
            jwt
        );
    };

    deleteTract = (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, jwt: string) => {
        return this.deleteRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}`,
            {},
            jwt
        );
    };

    deleteSection = (clientNumber: number, projectNumber: number, sectionNumber: number, jwt: string) => {
        return this.deleteRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}`, {}, jwt);
    };
    getTractsByOwner = (clientNumber: number, projectNumber: number, sectionNumber: number, ownerId: number, jwt: string) => {
        return this.getRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/ownerId/${ownerId}`,
            jwt
        );
    };
    getSurfaceTractsByOwner = (clientNumber: number, projectNumber: number, fieldNumber: number, ownerId: number, jwt: string): Promise<object> => {
        return this.getRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${fieldNumber}/surfaceTracts/ownerId/${ownerId}`,
            jwt
        );
    }
    deleteTownship = (clientNumber: number, projectNumber: number, townshipId: number, jwt: string) => {
        return this.deleteRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/townships/${townshipId}`, {}, jwt);
    };

    getSearchPagedOwners = (clientNumber: number, projectNumber: number, options: ODataOptions, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owner-search${options.toString()}`, jwt);
    }

    getSearchOwners = (clientNumber: number, projectNumber: number, searchText: string, ownerType: string, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/owner-search/${searchText}/${ownerType}`, jwt);
    };

    getFormations = (clientNumber: number, projectNumber: number) => {
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/formations`);
    };

    createFormation = (clientNumber: number, projectNumber: number, formation: Formation, jwt: string) => {
        return this.postRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/formations`, formation, jwt);
    };

    getPagedOwnerships = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        options: ODataOptions,
        jwt: string
    ) => {
        // tslint:disable-next-line:max-line-length
        return this.getRequest(
            `${
                this.baseUrl
            }v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/horizons/${horizonNumber}/paged-ownerships/${options.toString()}`,
            jwt
        );
    };

    sequenceHorizons = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        sequence: Array<{ id: number; sequence: number }>,
        jwt: string
    ) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/sequence-horizons`,
            sequence,
            jwt
        );
    };

    getUniqueHorizonIntervals = (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, jwt: string) => {
        const query = `?excludeSectionNumber=${sectionNumber}&excludeTractNumber=${tractNumber}`;
        return this.getRequest(`${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/horizon-intervals${query}`, jwt).then(
            (data: HorizonInterval[]) => {
                for (let i = 0; i < data.length; i++) {
                    const hi = data[i];

                    hi.from.type = this.getHorizonPartType((hi as AnyObject).from.type as number);
                    hi.to.type = this.getHorizonPartType((hi as AnyObject).to.type as number);
                }
                return data;
            }
        );
    };

    saveAddOwnership = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        owner: AddOwnershipData,
        jwt: string
    ) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/save-add-ownership`,
            owner,
            jwt
        );
    };

    getTractOwners = (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, jwt: string) => {
        return this.getRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/owners`,
            jwt
        );
    };

    getTownshipSectionsForSectionNumber = (clientNumber: number, projectNumber: number, sectionNumber: number, jwt: string) => {
        return this.getRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/township-sections-for-section`,
            jwt
        );
    };

    deleteOwnership = (clientNumber: number, projectNumber: number, sectionNumber: number, ownershipId: number, jwt: string) => {
        return this.deleteRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/delete-ownership/${ownershipId}`,
            {},
            jwt
        );
    };

    deleteHorizon = (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, horizonNumber: number, jwt: string) => {
        // tslint:disable-next-line:max-line-length
        return this.deleteRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/horizons/${horizonNumber}`,
            {},
            jwt
        );
    };

    promoteAdditionalOwnership = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        horizonNumber: number,
        ownershipId: number,
        jwt: string
    ) => {
        // tslint:disable-next-line:max-line-length
        return this.putRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/horizons/${horizonNumber}/ownerships/${ownershipId}/promote-additional-ownership`,
            {},
            jwt
        );
    };

    getCityState = (zipCode: string, jwt: string) => {
        return this.getRequest(`${this.baseUrl}v1.0/usps/${zipCode}/local-source`, jwt);
    };
}

export const TractUrl = {
    getTracts: (appContext: IAppContextState, fieldNumber: number, filter: string) => `${UrlFactory.ForProject(appContext)}/fields/${fieldNumber}/tracts${filter}`,
    getTract: (appContext: IAppContextState) => `${UrlFactory.ForTract(appContext)}`,
    addTagsToTract: (appContext: IAppContextState) => `${UrlFactory.ForTract(appContext)}/add-delete-tags`,
    addTagsToSurfaceTract: (appContext: IAppContextState, surfaceTractId: number) => `${UrlFactory.ForTract(appContext)}/surface-tracts/${surfaceTractId}/tags`,
    getEastTexasTracts: (appContext: IAppContextState, fieldNumber: number, filter: string) => `${UrlFactory.ForProject(appContext)}/fields/${fieldNumber}/east-texas-tracts${filter}`,
    getSurfaceTracts: (appContext: IAppContextState, fieldNumber: number, filter: string) => `${UrlFactory.ForProject(appContext)}/fields/${fieldNumber}/surfaceTracts${filter}`,
    horizon: (appContext: IAppContextState) => `${UrlFactory.ForHorizon(appContext)}`,
    ownership: (appContext: IAppContextState) => `${UrlFactory.ForOwnership(appContext)}`,
    copyLeasehold: (appContext: IAppContextState) =>
        `${UrlFactory.ForTract(appContext)}/ownership/${appContext.ownershipId}/leasehold/copy-leasehold`,
};


// WEBPACK FOOTER //
// ./src/api/Tract.ts